import sectionMoneyBackGuaranteeCss from '../css-snippets/section-money-back-guarantee';

const html = `
<style>${sectionMoneyBackGuaranteeCss}</style>
<div
  class="money-back-guarantee-wrapper"
  data-attribute="money-back-guarantee-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-button-border-radius="40"
  data-container-full-width="false"
>
  <div
    class="money-back-guarantee-container-wrapper container"
    data-attribute="money-back-guarantee-container-wrapper"
  >
    <div
      class="money-back-guarantee-container"
      data-attribute="money-back-guarantee-container"
    >
      <div
        class="money-back-guarantee-content"
        data-attribute="money-back-guarantee-content"
      >
        <div
          class="money-back-guarantee-header-wrapper"
          data-attribute="money-back-guarantee-header-wrapper"
        >
          <div class="shield-icon" data-attribute="shield-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              width="80"
              height="80"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8 16L4.35009 13.3929C2.24773 11.8912 1 9.46667 1 6.88306V3L8 0L15 3V6.88306C15 9.46667 13.7523 11.8912 11.6499 13.3929L8 16ZM12.2071 5.70711L10.7929 4.29289L7 8.08579L5.20711 6.29289L3.79289 7.70711L7 10.9142L12.2071 5.70711Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
          <div
            class="money-back-guarantee-header"
            data-attribute="money-back-guarantee-header"
          >
            <h2 style="text-align: center">
              <i>Money-Back</i> <strong>Guarantee</strong>
            </h2>
            <p style="text-align: center">
              We're so confident in the quality of our product that we offer a
              satisfaction guarantee. If you're not completely satisfied with
              your purchase, simply return the item within 30 days for a full
              refund.
            </p>
          </div>
        </div>

        <div
          class="money-back-guarantee-button"
          data-attribute="money-back-guarantee-button"
        >
          <a href="#" class="btn-claim-now" data-attribute="btn-claim-now">
            CLAIM NOW
          </a>
        </div>

        <div
          class="money-back-guarantee-footer"
          data-attribute="money-back-guarantee-footer"
        >
          <p style="text-align: center">
            <span style="color: hsl(0, 0%, 0%)">✔</span> 100% Satisfaction &nbsp;
            &nbsp;<span style="color: hsl(0, 0%, 0%)">✔ </span>Fast Shipping &nbsp;
            &nbsp;<span style="color: hsl(0, 0%, 0%)">✔</span> Secure Checkout
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
